import React from "react";
import { UDALOST } from "../lib/taby.js";

/**
 * Odkaz, který se otevře jako záložka uvnitř adminu.
 *
 * Dřív takové odkazy měly `target="_blank"`, takže se admin načítal znovu
 * v dalším okně prohlížeče. Tady se místo toho založí záložka v aplikaci:
 * stránka, na které člověk stojí, zůstane otevřená a jde se mezi nimi
 * přepínat.
 *
 * Je to opravdový `<a href>`, takže zvyky z prohlížeče platí dál: Ctrl
 * (na Macu Cmd), Shift i prostřední tlačítko otevřou okno prohlížeče.
 * Levé klepnutí bez klávesy dělá záložku.
 */
export default function ZalozkaLink({ to, title, className = "", children, onClick, ...rest }) {
  return (
    <a
      href={to}
      className={className}
      onClick={(e) => {
        onClick?.(e);
        if (e.defaultPrevented) return;
        // Klávesy a jiná než levá myš patří prohlížeči, ne nám.
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        window.dispatchEvent(new CustomEvent(UDALOST, {
          detail: { to, title: title || (typeof children === "string" ? children : "Detail") },
        }));
      }}
      {...rest}
    >
      {children}
    </a>
  );
}
